import { ContractManagerMain } from '../../organisms/contractManager/Main';
import { LandingTopWidget } from '../../organisms/landing';
import { LayoutSidebar } from '../../organisms/sidebar/LayoutSidebar';

const ContractManagerPage = () => (
  <div className='bg-neutral-10'>
    <LandingTopWidget />
    <LayoutSidebar>
      <ContractManagerMain />
    </LayoutSidebar>
  </div>
);

export default ContractManagerPage;
